export default __webpack_public_path__ + "static/media/smoking-pepe.4bb9c252.jpeg";